import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import { CheckedCircleBorderedIcon } from '../../../images/shapes';

interface SuccessIssueCreatedModalProps {
  /**
   * success issue created modal test id
   */
  testId?: string;
}

const SuccessIssueCreatedModal = ({
  testId = '',
}: SuccessIssueCreatedModalProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col items-center"
      {...getTestProps(testId, 'success-issue-created-modal')}
    >
      <CheckedCircleBorderedIcon className="w-14 h-14 text-lime-600 " />
      <span className="font-bold text-3xl my-4">
        {t('SupportIssueModal.Form.Success')}
      </span>
      <p className="mb-2 mx-10">
        {t('SupportIssueModal.Form.SuccessParagraph')}
      </p>
    </div>
  );
};

export default SuccessIssueCreatedModal;
